<template>
    <div id="app">
        <progress-indicator></progress-indicator>
        <router-view/>
        <notifications></notifications>
        <confirm></confirm>
        <modal></modal>
        <add-note v-if="showTextarea"></add-note>
        <transition name="button">
            <back-to-top v-if="showButton"></back-to-top>
        </transition>
        <transition name="fade">
            <div v-if="showFade"
                 class="page-fade">
            </div>
        </transition>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { UserData } from '@/common/auth/user-data';

    export default {
        name: 'App',
        components: {
            Modal:             () => import('@/components/modals/Modal'),
            Confirm:           () => import('@/components/popup/Confirm'),
            AddNote:           () => import('@/components/popup/AddNote'),
            BackToTop:         () => import('@/components/controls/BackToTop'),
            Notifications:     () => import('@/components/controls/Notifications'),
            ProgressIndicator: () => import('@/components/controls/ProgressIndicator')
        },
        data() {
            return {
                showFade: '',
                showButton: false
            }
        },
        computed: {
            ...mapGetters(['showTextarea'])
        },
        methods: {
            handleScroll() {
                const { userRole = null } = UserData.getUserDataFromLocalStorage() || {};
                if (userRole) {
                    this.showButton = window.scrollY > 0;
                } else {
                    this.showButton = false;
                }
            }
        },
        created() {
            window.addEventListener('scroll', this.handleScroll);

            this.$root.$on('show-fade', () => {
                this.showFade = true;
                document.body.classList.add('stop-scrolling');
            });
            this.$root.$on('hide-fade', () => {
                this.showFade = false;
                document.body.classList.remove('stop-scrolling');
            });
        },
        destroyed () {
            window.removeEventListener('scroll', this.handleScroll);
        }
    };
</script>

<style lang="scss" scoped>
    .page-fade {
        z-index: 7;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        opacity: 0.3;
        background-color: black;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue